import { useLocalStorage } from 'hooks';
import styled from 'styled-components';

const StyledText = styled.span<{ value: string }>`
    font-size: ${props => 12 * parseFloat(props.value)}px !important;
`;

type Props = {
    children: string;
};

const TinyText = ({ children }: Props) => {
    const [value] = useLocalStorage('size', '1');

    return (
        <StyledText value={value} style={{ fontSize: 10 }}>
            {children}
        </StyledText>
    );
};

export default TinyText;
